import {TimeScale} from '@app/review/timescale';

export class TimeRange {
    private _start: number;
    private _end: number;

    constructor(start: number, end: number) {
        this._start = start;
        this._end = end;
    }

    get isValid(): boolean {
        return this._start !== null || this._end !== null;
    }

    get start() {
        return this._start;
    }

    set start(value: number) {
        this._start = value;
    }

    get end(): number {
        return this._end;
    }

    set end(value: number) {
        this._end = value;
    }

    public toArray(): number[] {
        return [this._start || -1, this._end || -1];
    }

    public fromArray(range: number[]): void {
        this._start = null;
        this._end = null;

        if (range.length === 1) {
            // start only
            this._start = range[0] === -1 ? null : range[0];
        } else if (range.length === 2) {
            this._start = range[0] === -1 ? null : range[0];
            this._end = range[1] === -1 ? null : range[1];
        }
    }

    public left(timeScale: TimeScale): number {
        if (this._start === null) {
            return 0;
        }
        return timeScale.timeToOffset(this._start);
    }

    public right(timeScale: TimeScale): number {
        if (this._end === null) {
            return timeScale.frameCount;
        }
        return timeScale.timeToOffset(this._end);
    }

    public width(timeScale: TimeScale): number {
        if (this._end === null) {
            return 100 - this.left(timeScale);
        }
        return timeScale.timeToOffset(this._end) - timeScale.timeToOffset(this._start);
    }

    public contains(frame: number, timeScale: TimeScale): boolean {
        const start = timeScale.timeToFrame(this._start || 0);
        const end = this._end ? timeScale.timeToFrame(this._end) : timeScale.frameCount;

        return frame >= start && frame <= end;
    }
}
